var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalyticsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9893 22.141H3.15029C1.93329 22.141 0.946289 21.139 0.946289 19.9V3.94C0.946289 1.856 1.93329 0.852997 3.15029 0.852997H21.6703H21.2953H22.9893C24.2073 0.852997 25.1953 1.856 25.1953 3.94V19.9C25.1953 21.139 24.2073 22.141 22.9893 22.141ZM22.9893 13.109L22.1183 13.996L17.8003 9.60699L13.3913 15.21L9.99229 11.755L8.74129 13.26C8.57629 14.258 7.54929 15.21 6.29329 15.21C4.92229 15.21 3.81029 14.8 3.81029 12.686C3.81029 11.293 4.92229 10.163 6.29329 10.163C6.89329 10.163 7.43629 10.388 7.86529 10.748L9.99229 8.586L13.2083 11.854L17.6173 6.252L22.1183 10.826L22.9893 9.939V3.94H21.2953H21.6703H3.15029V19.9H22.9893V13.109ZM7.86029 19.205H4.88229V15.846H7.86029V19.205ZM11.4963 19.205H9.29129V13.605H11.4963V19.205ZM15.9053 19.205H13.7013V15.846H15.9053V19.205ZM20.3153 19.205H18.1103V13.605H20.3153V19.205Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsActive);
export default __webpack_public_path__ + "static/media/analytics-active.93daa46cb110ce71cebd6029cb7bf88c.svg";
export { ForwardRef as ReactComponent };